var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex--center clickable actionButton circle",class:{
    absolute: _vm.absolute,
    'rotate--90': _vm.rotate,
    'actionButton--accent': _vm.accent,
    'actionButton--light': _vm.light,
  },on:{"click":function (e) { return _vm.$emit('onClick', e); },"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return (function (e) { return _vm.$emit('onClick', e); })($event)}}},[_c('i',{staticClass:"font--s2",class:_vm.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }